module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Mail-attachment-450b3dd3beef75cb759437acae10feb2.svg";